import axios from 'axios';
import { BACKEND_URL } from '../../config';

const API = `${BACKEND_URL}/api`;

// Spam signals sent with every enquiry (see backend comms/spam.py): the hidden HoneyPot box and
// how long the visitor spent on the page before sending – people take more than a few seconds.
const PAGE_OPENED = Date.now();
const spamSignals = () => {
  let hp = '';
  try { hp = [...document.querySelectorAll('input[name="vk_website"]')].map((i) => i.value).join(''); } catch { /* no DOM */ }
  return { hp, fill_ms: Math.min(Date.now() - PAGE_OPENED, 3600e3) };
};

/**
 * Save a website enquiry. Uses the live /api/inquiries endpoint and also pushes
 * the lead into CRM v2 so it shows up for the sales team. Succeeds if either works.
 */
export async function submitEnquiry({ name, email, phone, message, packageId, packageTitle, destination, travelDate, travelers, productType = 'tour' }) {
  const notes = [packageTitle ? `Package: ${packageTitle}` : null, message || null].filter(Boolean).join('\n');
  const sig = spamSignals();
  const results = await Promise.allSettled([
    axios.post(`${API}/inquiries`, {
      name,
      email,
      phone,
      message: notes || null,
      package_id: packageId || null,
      destination: destination || null,
      travel_date: travelDate || null,
      num_travelers: travelers ? Number(travelers) : null,
      ...sig,
    }),
    axios.post(`${API}/crm/v2/leads/capture`, {
      name,
      email: email || '',
      phone,
      source: 'website',
      product_type: productType,
      destination: destination || '',
      travel_date: travelDate || '',
      travelers: travelers ? Number(travelers) : 1,
      notes,
      ...sig,
    }),
  ]);
  if (results.some((r) => r.status === 'fulfilled')) {
    // Every website form counts as a lead in GA4 and as the Google Ads lead-form conversion
    try {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', { form: productType, destination: destination || '', page_path: window.location.pathname });
        window.gtag('event', 'conversion', { send_to: 'AW-17680721341/Uu1uCPahtq8dEL3L6e5B' });
      }
    } catch { /* tracking must never break the form */ }
    return true;
  }
  throw results[0].reason || new Error('Enquiry failed');
}
